var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppLayout",
    {
      ref: "layout",
      attrs: {
        page: "/dashboard",
        pageTitle: `${_vm.eventRegister.name}`,
        backLink: "/dashboard/reports/event-history",
        selectedPeople: _vm.selectedPeople,
        hasFab: !!_vm.selectedPeople.length,
        fabLoading: _vm.loading,
      },
      on: {
        fabAction: function ($event) {
          _vm.selectedPeople.length ? _vm.emailUsers() : null
        },
      },
    },
    [
      _c(
        "v-col",
        { staticClass: "pa-1", attrs: { cols: "12" } },
        [
          _c("Stats", { staticClass: "pb-3", attrs: { stats: _vm.stats } }),
          _vm._v(" "),
          _c(
            "v-card",
            { staticClass: "soli-round" },
            [
              _c(
                "v-container",
                { staticClass: "px-3", attrs: { fluid: "" } },
                [
                  _c("ReportHeader", {
                    attrs: {
                      staticDate: _vm.eventRegister.date,
                      subtitle: `${_vm.eventRegister.time} | ${_vm.eventRegister.location} | ${_vm.eventRegister.teacher?.name}`,
                      filter: "",
                      dateSelection: false,
                    },
                    on: {
                      search: function ($event) {
                        _vm.search = $event
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("v-data-table", {
                    ref: "table",
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.registered,
                      "hide-default-footer": "",
                      "disable-pagination": "",
                      "mobile-breakpoint": "0",
                      "show-select": "",
                      search: _vm.search,
                      "item-key": "hash_id",
                    },
                    on: {
                      "click:row": function ($event) {
                        ;[_vm.$log($event.id)]
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: `item.info.name`,
                          fn: function ({ item }) {
                            return [
                              _c(
                                "v-list-item",
                                {
                                  staticClass: "soli-grey px-0",
                                  staticStyle: { width: "min-content" },
                                },
                                [
                                  _c(
                                    "v-list-item-avatar",
                                    [
                                      _c("v-img", {
                                        attrs: {
                                          src: item.info.profile_photo_url,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-item-content",
                                    [
                                      item.info.id
                                        ? _c(
                                            "Link",
                                            {
                                              attrs: {
                                                href: `/profile/${item.info.id}/account`,
                                              },
                                            },
                                            [
                                              _c("v-list-item-title", [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(item.info.name) +
                                                    "\n                                    "
                                                ),
                                              ]),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-item-subtitle",
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(item.info.email) +
                                              "\n                                    "
                                          ),
                                          _c("Clipboard", {
                                            attrs: {
                                              text: item.info.email,
                                              label: "Copy Email",
                                              "x-small": "",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: `item.child.name`,
                          fn: function ({ item }) {
                            return [
                              _c(
                                "div",
                                { staticClass: "d-flex align-center py-2" },
                                [
                                  _c(
                                    "div",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(item.child?.name) +
                                            "\n                                "
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                        {
                          key: `item.status`,
                          fn: function ({ item }) {
                            return [
                              _c(
                                "v-chip",
                                {
                                  staticClass: "white--text font-bold",
                                  attrs: {
                                    small: "",
                                    color:
                                      item.status == "Unpaid"
                                        ? "soli-status-red"
                                        : "soli-status-green",
                                  },
                                },
                                [_vm._v(_vm._s(item.status))]
                              ),
                            ]
                          },
                        },
                        {
                          key: `item.contract_url`,
                          fn: function ({ item }) {
                            return [
                              _c(
                                "div",
                                { staticClass: "d-flex align-center py-2" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        href: item.contract_url
                                          ? _vm.route(
                                              "contract.view",
                                              item.hash_id
                                            )
                                          : _vm.route(
                                              "users.show",
                                              item.info.id
                                            ),
                                        rounded: "",
                                        target: "_blank",
                                        small: "",
                                        outlined: "",
                                        color: "accent",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "pr-1",
                                          class: [
                                            item.contract_url
                                              ? "primary--text"
                                              : "error--text",
                                          ],
                                          attrs: { small: "" },
                                        },
                                        [_vm._v("description")]
                                      ),
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            item.contract_url ? "View" : "Sign"
                                          ) +
                                          "\n                            "
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: `item.created_at`,
                          fn: function ({ item }) {
                            return [
                              _c("div", [_vm._v(_vm._s(item.created_at))]),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                    model: {
                      value: _vm.selectedPeople,
                      callback: function ($$v) {
                        _vm.selectedPeople = $$v
                      },
                      expression: "selectedPeople",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.composeEmail
        ? _c("ComposeEmail", {
            attrs: {
              emails: _vm.selectedEmails,
              signature: "",
              sendAsStudio: "",
              tinyMCE: "",
              user: _vm.$page.props.auth.user,
              errors: _vm.errors,
            },
            on: {
              success: function ($event) {
                return _vm.emailSuccess()
              },
              reset: function ($event) {
                _vm.closeModal(() => (_vm.composeEmail = false))
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }